<template>
    <div>
        <v-card elevation="0">
            <v-data-table
                :headers="headers"
                :items="details"
                :itemsPerPage="itemsPerPage"
                hide-default-footer
                class="detail-table"
            >
                <template v-slot:item.show_expiration_alert="{ item }">
                    <div v-if="item.show_expiration_alert">
                        <v-btn icon x-small @click="snackbar = true">
                            <v-icon small :color="!item.expires_tomorrow ? 'error' : 'grey'">
                                mdi-bell-badge-outline
                            </v-icon>
                        </v-btn>
                        <v-snackbar v-model="snackbar" :timeout="-1" absolute bottom color="primary" left text>
                            il Prodotto ha un'anomalia!
                            <template v-slot:action="{ attrs }">
                                <v-btn color="error" text v-bind="attrs" @click="snackbar = false">
                                    Chiudi
                                </v-btn>
                            </template>
                        </v-snackbar>
                    </div>
                </template>
                <template v-slot:item.delivery_date="{ item }">
                  <div class="text-center">
                    <v-chip
                      v-if="item.delivery_date"
                      color="primary"
                      text-color="white"
                      small
                      class="font-weight-medium"
                    >
                      {{ formatDate(item.delivery_date) }}
                    </v-chip>
                    <span v-else>-</span>
                  </div>
                </template>
                <template v-slot:item.count="{item, index}">
                    <div class="text-center">{{ index + 1 }}</div>
                </template>
                <template #item.operator_name="{ item }">
                  <div class="text-start">
                    <v-select
                      class="custom operator-select"
                      @input="salvaOperatori(item)"
                      dense
                      v-model="item.operators"
                      :menu-props="{ top: true, offsetY: true }"
                      :items="operatori"
                      item-value="id"
                      item-text="full_name"
                      multiple
                      persistent-hint
                  >
                    <template #selection="{ item }">
                      <v-chip dark small color="primary" class="font-weight-medium">{{item.last_name}}</v-chip>
                    </template>
                  </v-select>
                  </div>
<!--                    <div v-for="(name, index) in item.operator_name" :key="index" class="d-inline-flex">-->
<!--                        <v-chip x-small dark label color="if65Blue" class="ml-1">-->
<!--                            {{ name }}-->
<!--                        </v-chip>-->
<!--                    </div>-->
                </template>
                <template #item.status="{ item }">
                  <div class="text-center">
                    <v-select
                        class="custom status-select"
                        @input="salvaStato(item)"
                        chips
                        dense
                        :menu-props="{ top: true, offsetY: true }"
                        v-model="item.status"
                        :items="stati"
                        item-text="text"
                        item-value="value">
                      <template #selection="{ item }">
                        <v-chip dark small :color="getColor(item.value)" class="font-weight-medium">{{item.text}}</v-chip>
                      </template>
                    </v-select>
                  </div>
                </template>
                <template #item.actions="{ item, index }">
                    <div class="d-flex justify-center">
                        <v-tooltip top v-if="item.notified">
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    :loading="loading[index]"
                                    @click="sendEmail(item, loading[index] = true)"
                                    icon
                                    x-small
                                    color="success"
                                    class="mr-1"
                                    v-on="tooltip"
                                >
                                    <v-icon small>mdi-email-check-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Notifica Inviata</span>
                        </v-tooltip>
                        <v-tooltip top v-else>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    :loading="loading[index]"
                                    @click="sendEmail(item, loading[index] = true)"
                                    icon
                                    x-small
                                    color="primary"
                                    class="mr-1"
                                    v-on="tooltip"
                                >
                                    <v-icon small>mdi-email-fast</v-icon>
                                </v-btn>
                            </template>
                            <span>Invia Notifica</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<style scoped>
/* ALLINEAMENTO VERTICALE CENTRATO - DIRETTO SULLA TABELLA */
.detail-table >>> tbody td {
  vertical-align: middle !important;
  padding: 12px 16px !important;
}

.detail-table >>> thead th {
  vertical-align: middle !important;
}

.detail-table >>> .v-data-table__wrapper tbody tr {
  height: 56px !important;
}

.detail-table >>> .v-data-table__wrapper tbody tr td {
  vertical-align: middle !important;
  height: 56px !important;
}

/* Forza l'allineamento di tutti i contenuti */
.detail-table >>> td .v-input {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.detail-table >>> td .v-select {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.detail-table >>> td .v-chip {
  margin: 2px !important;
}

.detail-table >>> td .text-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  min-height: 56px !important;
}

.detail-table >>> td .text-start {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
  min-height: 56px !important;
}

/* Centramento specifico per le celle con select */
.detail-table >>> td:has(.custom.v-select) {
  vertical-align: middle !important;
  padding: 8px !important;
}

.detail-table >>> td .custom.v-select {
  width: 100% !important;
}
</style>

<script>
// import If65Autocomplete from '../widgets/If65Autocomplete.vue'


import {format, parseISO} from "date-fns";
// import If65Autocomplete from "@/components/widgets/If65Autocomplete.vue";

export default {
    name: "ListDetails",
  props: {
    id: {
      required: true
    },
    projectCode: {
      required: true
    },
    statusToSearch: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      headers: [
        { text: '', value: 'show_expiration_alert', class: "primary--text font-weight-medium text-center", width: '5px', sortable:false, align: 'center' },
        { text: 'Scadenza', value: 'delivery_date', class: "primary--text font-weight-medium text-center", width: '110px', sortable:false, align: 'center'},
        { text: 'N#', value: 'count', class: "primary--text font-weight-medium text-center", width: '50px', sortable:false, align: 'center' },
        { text: 'Nome Attività', value: 'activity_name', class: "primary--text font-weight-medium", sortable:false, align: 'start' },
        { text: 'Prodotto', value: 'name', class: "primary--text font-weight-medium", sortable:false, align: 'start' },
        { text: 'Operatori', value: 'operator_name', class: "primary--text font-weight-medium", sortable:false, align: 'start' },
        { text: 'Stato', value: 'status', class: "primary--text font-weight-medium text-center", sortable:false, align: 'center' },
        { text: 'Act.', value: 'actions', class: "primary--text font-weight-medium text-center", width: '80px', sortable:false, align: 'center' },
      ],
      details: [],
      loading: {},
      itemsPerPage: 50,
      snackbar: false,
      stato:'',
      stati: [
        {value:'DAASSEGNARE', text: 'Da Assegnare'},
        {value:'ASSEGNATO', text: 'Assegnato'},
        {value:'INLAVORAZIONE', text: 'In Lavorazione'},
        {value:'INAPPROVAZIONE', text: 'In Approvazione'},
        {value:'APPROVATO', text: 'Approvato'},
        {value:'INVALFORNITORE', text: 'Inv. al Fornitore'},
        {value:'LAVOROCHIUSO', text: 'Lavoro Chiuso'}
      ],
      operatori:[]
    }
  },
  mounted() {
    this.initDetails()
    this.getOperatori()
  },
  watch: {
    value: {
      handler() {
        this.show = this.value
      },
      immediate: true
    },
  },
  methods: {
    formatDate(isoDate) {
      return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : ''
    },
    initDetails() {
      this.$productService.list({project: this.id, status:this.statusToSearch})
          .then(resp => {
            this.details = resp.data
          })
    },
    getColor (status) {
      if (status === 'DAASSEGNARE') return 'error'
      else if (status === 'ASSEGNATO') return 'primary'
      else if (status === 'INLAVORAZIONE') return 'success'
      else if (status === 'INAPPROVAZIONE') return 'info'
      else if (status === 'INVALFORNITORE') return 'info'
      else if (status === 'LAVOROCHIUSO') return 'success darken-2'
      else return 'secondary'
      // DAASSEGNARE
      // ASSEGNATO
      // INLAVORAZIONE
      // INAPPROVAZIONE
      // APPROVATO
      // INVALFORNITORE
      // LAVOROCHIUSO
    },
    sendEmail(item) {
      item.notified = true
      this.$projectService.sendNotifications(item)
          .then(resp => {
            console.log(resp)
            this.loading = {}
            this.initDetails()
            this.$dtoast.pop({
              rounded:"pill",
              preset: "success",
              content: `${resp.data.message}`,
            })
          }).catch(xhr => {
        this.$root.$emit('renderError', xhr)
      })

    },
    salvaOperatori(item) {
      if (item.operators.length === 1 && item.status === 'DAASSEGNARE') {
        let status = {
          operators: item.operators,
          status: 'ASSEGNATO'
        }
        this.$productService.patch(item.id, status)
        .then(() => {
            // Aggiorniamo solo lo stato locale senza ricaricare
            item.status = status.status;
            this.$dtoast.pop({
              rounded:"pill",
              preset: "success",
              content: `Operatori e stato aggiornati con successo`,
            })
          }).catch(xhr => {
        this.$root.$emit('renderError', xhr)
      })
      } else {
        let data = {
          operators: item.operators
        }
        this.$productService.patch(item.id, data)
            .then(() => {
              // Non ricarichiamo più tutti i dettagli
              this.$dtoast.pop({
                rounded: "pill",
                preset: "success",
                content: `Operatori aggiornati con successo`,
              })
            }).catch(xhr => {
          this.$root.$emit('renderError', xhr)
        })
      }
    },
    salvaStato(item) {
      let data = {
        status: item.status
      }
      this.$productService.patch(item.id, data)
      .then(() => {
            // Non ricarichiamo più tutti i dettagli, solo il toast di conferma
            this.$dtoast.pop({
              rounded:"pill",
              preset: "success",
              content: `Stato cambiato con successo`,
            })
          }).catch(xhr => {
        this.$root.$emit('renderError', xhr)
      })
    },
    getOperatori() {
      this.$userService.list()
          .then(resp => {
            this.operatori = resp.data
          })
          .catch()
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}
.custom.v-text-field>.v-input__control>.v-input__slot:before,
.custom.v-select>.v-input__control>.v-input__slot:before {
    border-style: none !important;
    border: none !important;
}
.custom.v-text-field>.v-input__control>.v-input__slot:after,
.custom.v-select>.v-input__control>.v-input__slot:after {
    border-style: none !important;
    border: none !important;
}

/* Rimuove TUTTE le barre dalle select custom - stili più specifici */
.detail-table >>> .custom.v-select .v-input__slot {
    border: none !important;
    border-bottom: none !important;
    box-shadow: none !important;
}

.detail-table >>> .custom.v-select .v-input__slot:before,
.detail-table >>> .custom.v-select .v-input__slot:after {
    display: none !important;
    border: none !important;
    border-bottom: none !important;
    content: none !important;
}

.detail-table >>> .custom.v-select:hover .v-input__slot:before,
.detail-table >>> .custom.v-select:hover .v-input__slot:after {
    display: none !important;
}

.detail-table >>> .custom.v-select.v-input--is-focused .v-input__slot:before,
.detail-table >>> .custom.v-select.v-input--is-focused .v-input__slot:after {
    display: none !important;
}

/* Forza la rimozione di tutti i bordi possibili */
.detail-table >>> .custom.v-select .v-input__control {
    border: none !important;
}

.detail-table >>> .custom.v-select .v-input__control .v-input__slot {
    border: none !important;
    border-bottom: none !important;
}

.custom.v-select .v-chip {
    margin: 0 auto;
}

/* Allineamento verticale perfetto delle select */
.detail-table >>> .custom.v-select {
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
    min-height: 56px !important;
}

.detail-table >>> .custom.v-select .v-input__control {
    min-height: 32px !important;
    height: 32px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
}

.detail-table >>> .custom.v-select .v-input__slot {
    min-height: 32px !important;
    height: 32px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
}

.detail-table >>> .custom.v-select .v-input__append-inner {
    margin: 0 !important;
    padding: 0 !important;
    align-self: center !important;
}

.detail-table >>> .custom.v-select .v-select__selections {
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    height: 32px !important;
    line-height: 32px !important;
}

/* Riduzione della larghezza della select dello stato */
.status-select {
    max-width: 150px !important;
    margin: 0 auto !important;
}

/* Impostazione della larghezza della select degli operatori */
.operator-select {
    max-width: 250px !important;
}

.detail-table {
  border-radius: 8px;
  overflow: hidden;
  background-color: white !important;
}

.detail-table .v-data-table__wrapper {
  overflow-x: auto;
}

.detail-table table {
  border-spacing: 0;
}

.detail-table tbody tr {
  transition: background-color 0.2s ease;
  background-color: white !important;
}

.detail-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.detail-table tbody td {
  font-size: 0.875rem;
  padding: 8px 16px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.detail-table thead th {
  font-size: 0.875rem;
  padding: 12px 16px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  background-color: white !important;
  color: var(--v-primary-base) !important;
  font-weight: 600 !important;
}
</style>
